// src/data/mockStudents.js
export const mockStudents = [
  {
    id: "S001",
    firstName: "Juan",
    lastName: "Dela Cruz",
    fullname: "Juan Dela Cruz",
    dob: "2009-04-12",
    gender: "Male",
    address: "Brgy. 1, Gapan",
    contact: "0917-111-2222",
    gradeLevel: "Grade 10",
    strand: "Excellence",
    campus: "gapan",
    photo: "/vmsc_logo.png", // placeholder
    enrollmentYear: 2024,
    subjects: [
      { code: "MATH101", name: "Mathematics", teacher: "Mrs. Reyes", q1: 88, q2: 90, q3: 89, q4: 91 },
      { code: "ENG101", name: "English", teacher: "Mr. Cruz", q1: 85, q2: 87, q3: 86, q4: 88 },
    ],
  },
  {
    id: "S002",
    firstName: "Maria",
    lastName: "Santos",
    fullname: "Maria Santos",
    dob: "2008-09-20",
    gender: "Female",
    address: "Brgy. 2, Bulacan",
    contact: "0918-333-4444",
    gradeLevel: "Grade 11",
    strand: "STEM",
    campus: "bulacan",
    photo: "/vmsc_logo.png",
    enrollmentYear: 2024,
    subjects: [
      { code: "BIO101", name: "Biology", teacher: "Ms. Lopez", q1: 92, q2: 90, q3: 93, q4: 94 },
      { code: "MATH201", name: "Advanced Math", teacher: "Mr. Tan", q1: 89, q2: 88, q3: 90, q4: 91 },
    ],
  }
];
